import { render } from "./OrderPage.vue?vue&type=template&id=5791aea0&ts=true"
import script from "./OrderPage.vue?vue&type=script&lang=ts"
export * from "./OrderPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__